module.exports = __webpack_public_path__ + "static/media/chrome.c365dfbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/browsers/chrome.svg
// module id = 273
// module chunks = 0